import axios, { AxiosInstance, AxiosRequestHeaders } from 'axios';
import { instrumentAxios } from '../shared/honeycomb/axiosHoneyCombTelemetry';
import { getAuthorizationToken, getBaseURLWithVersion } from './clientHelpers';
import { ClaimScoreApiVersion } from './types';

export const createClaimScoreApiClient = (
  version: ClaimScoreApiVersion = ClaimScoreApiVersion.V2,
): AxiosInstance => {
  const versionedBaseURL = getBaseURLWithVersion(version);

  const client: AxiosInstance = axios.create({
    baseURL: versionedBaseURL,
  });

  instrumentAxios(client, {
    tracerName: 'claimscore-api-service',
  });

  client.interceptors.request.use(
    async (config) => {
      const token = await getAuthorizationToken();

      config.headers ??= {} as AxiosRequestHeaders;
      config.headers.Authorization = `${token}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  return client;
};

const claimScoreApiServiceClient: AxiosInstance = createClaimScoreApiClient(
  ClaimScoreApiVersion.V2,
);

export default claimScoreApiServiceClient;
